module.exports = __webpack_public_path__ + "img/noPoster.fff7ff54.png";